export default __webpack_public_path__ + "static/media/icon1.cb7bf2b0.svg";